<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :customer-segment="customerSegment"
            @form-submitted="updateCustomerSegments"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/CustomerSegments/Form'

export default {
    name: 'CustomerSegmentsEdit',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        customerSegment: {
            type: Object,
            default: () => { return {} }
        }
    },
    methods: {
        updateCustomerSegments (form) {
            form.put(this.$route('settings.customer-segments.update', {
                customer_segment: this.customerSegment.id
            }))
        }
    }
}
</script>
